import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import VoteRow from './VoteRow'

class ShowVotes extends Component {
  dismissPopup () {
    this.props.dispatch(actions.switchShowVotes({}))
  }

  render () {
    const votes = this.props.payload
    const { players, teams } = this.props

    return (
      <div className='dashboard-popup-notif' >
        <div className='hey-popup-header'>
          <h4 className='header-text'>All Unique Votes</h4>
          <button
            onClick={this.dismissPopup.bind(this)}
            className='black-cross'>
            <img alt='' src='/imgs/close.png' />
          </button>
        </div>
        <div className='votes-header'>
          <div className='cell-name'>Name and team</div>
          <div className='cell-answer'>Answer</div>
        </div>
        <div className='line votes-view'>
          <div>
            {votes.map(v =>
              <VoteRow
                key={v._id}
                vote={v}
                player={players.find(p => p.id === v.participant)}
                team={teams.find(t => t.id === players.find(p => p.id === v.participant).team)}
              />)}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    payload: state.popup.payload,
    players: state.participants,
    teams: state.team.teams
  }
}

export default connect(mapStateToProps)(ShowVotes)



// WEBPACK FOOTER //
// ./src/components/common/popups/ShowVotes.js